import AfishaLogo from './AfishaLogo'
import ChampionatLogo from './ChampionatLogo'
import EdaLogo from './EdaLogo'
import FerraLogo from './FerraLogo'
import GazetaLogo from './GazetaLogo'
import IndicatorLogo from './IndicatorLogo'
import LentaLogo from './LentaLogo'
import LetidorLogo from './LetidorLogo'
import MoslentaLogo from './MoslentaLogo'
import MotorLogo from './MotorLogo'
import PassionLogo from './PassionLogo'
import QutoLogo from './QutoLogo'
import RamblerLogo from './RamblerLogo'
import RamblerMailLogo from './RamblerMailLogo'
import RamblerTop100Logo from './RamblerTop100Logo'
import SecretLogo from './SecretLogo'
import WmjLogo from './WmjLogo'

export const logos = [
  {
    Icon: RamblerLogo,
    domain: 'www.rambler.ru',
    desktop: 128,
    mobile: 77
  },
  {
    Icon: LentaLogo,
    domain: 'lenta.ru',
    desktop: 117,
    mobile: 71
  },
  {
    Icon: ChampionatLogo,
    domain: 'www.championat.com',
    desktop: 152,
    mobile: 92
  },
  {
    Icon: AfishaLogo,
    domain: 'www.afisha.ru',
    desktop: 130,
    mobile: 78
  },
  {
    Icon: RamblerMailLogo,
    domain: 'mail.rambler.ru',
    desktop: 150,
    mobile: 84
  },
  {
    Icon: SecretLogo,
    domain: 'secretmag.ru',
    desktop: 97,
    mobile: 59
  },
  {
    Icon: GazetaLogo,
    domain: 'www.gazeta.ru',
    desktop: 127,
    mobile: 76
  },
  {
    Icon: LetidorLogo,
    domain: 'letidor.ru',
    desktop: 119,
    mobile: 72
  },
  {
    Icon: RamblerTop100Logo,
    domain: 'top100.rambler.ru',
    desktop: 160,
    mobile: 90
  },
  {
    Icon: MoslentaLogo,
    domain: 'moslenta.ru',
    desktop: 165,
    mobile: 99
  },
  {
    Icon: MotorLogo,
    domain: 'motor.ru',
    desktop: 115,
    mobile: 69
  },
  {
    Icon: PassionLogo,
    domain: 'www.passion.ru',
    desktop: 149,
    mobile: 90
  },
  {
    Icon: WmjLogo,
    domain: 'www.wmj.ru',
    desktop: 126,
    mobile: 76
  },
  {
    Icon: IndicatorLogo,
    domain: 'indicator.ru',
    desktop: 146,
    mobile: 88
  },
  {
    Icon: QutoLogo,
    domain: 'quto.ru',
    desktop: 114,
    mobile: 69
  },
  {
    Icon: EdaLogo,
    domain: 'eda.ru',
    desktop: 94,
    mobile: 49
  },
  {
    Icon: FerraLogo,
    domain: 'www.ferra.ru',
    desktop: 121,
    mobile: 73
  }
]
